import type { SignInWithPasswordlessCredentials } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';

// Logger removed to avoid circular dependency

import { useSupabase } from './use-supabase';

export function useSignInWithOtp() {
  const client = useSupabase();
  const mutationKey = ['auth', 'sign-in-with-otp'];

  const mutationFn = async (credentials: SignInWithPasswordlessCredentials) => {
    const result = await client.auth.signInWithOtp(credentials);

    if (result.error) {
      if (shouldIgnoreError(result.error.message)) {
        console.warn('Ignoring error during development', {
          service: 'auth',
          function: 'signInWithOtp',
          error: result.error.message,
        });

        return result.data;
      }

      throw result.error;
    }

    return result.data;
  };

  return useMutation({
    mutationFn,
    mutationKey,
  });
}

export default useSignInWithOtp;

function shouldIgnoreError(error: string) {
  return isSmsProviderNotSetupError(error);
}

function isSmsProviderNotSetupError(error: string) {
  return error.includes(`sms Provider could not be found`);
}
